var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    fill: "#FF4D4D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 24.9609C33.3333 24.9609 29.1667 28.2943 27.5 34.9609C30 31.6276 32.9167 30.3776 36.25 31.2109C38.1519 31.6864 39.5112 33.0661 41.0158 34.5934C43.4669 37.0814 46.3038 39.9609 52.5 39.9609C59.1667 39.9609 63.3333 36.6276 65 29.9609C62.5 33.2943 59.5833 34.5443 56.25 33.7109C54.3481 33.2355 52.9888 31.8558 51.4842 30.3284C49.0331 27.8405 46.1962 24.9609 40 24.9609ZM27.5 39.9609C20.8333 39.9609 16.6667 43.2943 15 49.9609C17.5 46.6276 20.4167 45.3776 23.75 46.2109C25.6519 46.6864 27.0112 48.0661 28.5158 49.5934C30.9669 52.0814 33.8038 54.9609 40 54.9609C46.6667 54.9609 50.8333 51.6276 52.5 44.9609C50 48.2943 47.0833 49.5443 43.75 48.7109C41.8481 48.2355 40.4888 46.8558 38.9842 45.3284C36.5331 42.8405 33.6962 39.9609 27.5 39.9609Z",
    fill: "url(#paint0_linear_346_54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24.9609C33.3333 24.9609 29.1667 28.2943 27.5 34.9609C30 31.6276 32.9167 30.3776 36.25 31.2109C38.1519 31.6864 39.5112 33.0661 41.0158 34.5934C43.4669 37.0814 46.3038 39.9609 52.5 39.9609C59.1667 39.9609 63.3333 36.6276 65 29.9609C62.5 33.2943 59.5833 34.5443 56.25 33.7109C54.3481 33.2355 52.9888 31.8558 51.4842 30.3284C49.0331 27.8405 46.1962 24.9609 40 24.9609ZM27.5 39.9609C20.8333 39.9609 16.6667 43.2943 15 49.9609C17.5 46.6276 20.4167 45.3776 23.75 46.2109C25.6519 46.6864 27.0112 48.0661 28.5158 49.5934C30.9669 52.0814 33.8038 54.9609 40 54.9609C46.6667 54.9609 50.8333 51.6276 52.5 44.9609C50 48.2943 47.0833 49.5443 43.75 48.7109C41.8481 48.2355 40.4888 46.8558 38.9842 45.3284C36.5331 42.8405 33.6962 39.9609 27.5 39.9609Z",
    fill: "url(#paint1_linear_346_54)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_346_54",
    x1: 13.6111,
    y1: 34.5609,
    x2: 56.7943,
    y2: 59.4594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_346_54",
    x1: 13.6111,
    y1: 34.5609,
    x2: 56.7943,
    y2: 59.4594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/Tailwind.f574795c1b9ee0c6552e988c04140e51.svg";
export { ForwardRef as ReactComponent };